import React from 'react';
import { Navigate } from 'react-router-dom';

const ProtectedRoute = ({ children }) => {
  const isAuthenticated = localStorage.getItem('authToken'); // You can also use sessionStorage or context

  return isAuthenticated ? children : <Navigate to="/login" />;
};

export default ProtectedRoute;
